// Athlete role values: the new canonical `athlete` plus the legacy values the
// backend still emits during the compatibility window.
export const ATHLETE_ROLES = ['athlete', 'base_user', 'player_parent'];
export const isAthlete = (role) => ATHLETE_ROLES.includes(role);
// NOTE: "is this athlete premium?" must be derived from subscription status,
// not role. Use isAthlete only for "is this an athlete-side account" checks.
